module.exports = __webpack_public_path__ + "static/blue-receive-38d68228f20e0de94e02cb930ce1f43a.jpg";